import React, { useEffect, useContext, useState } from "react";
import "./trix.scss";
import { MainContext } from "../context/main";
import { fetchPut, fetchGet } from "../utils";
import TrixEditor from "./editors/trix";
//import MarkdownEditor from "./editors/markdown";

export default function Editor(props) {
  const [showEditorSelect, setShowEditorSelect] = useState(false);
  const { mainStore, mainDispatch } = useContext(MainContext);

  useEffect(() => {
    (async () => {
      if (!mainStore.user || !mainStore.user._id) {
        const { body } = await fetchGet({ url: "/api/user" });
        console.log("body");
        console.log(body);
        mainDispatch({ type: "MAIN_SET_USER", user: body });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //const {
  //defaultValue,
  //defaultRawValue,
  //handleChange,
  //handleFocus,
  //handleBlur,
  //handleInitialize,
  //handleFileAccepted,
  //handleAttachmentAdd,
  //handleAttachmentRemove,
  //handleSelectionChange,
  //handleBeforeInitialize,
  //} = props;
  console.log("mainStore.user");
  console.log(mainStore.user);
  return !mainStore.user || !mainStore.user._id ? null : (
    <>
      <div>
        {!showEditorSelect ? (
          <button
            className="link-button pl-0"
            onClick={() => setShowEditorSelect(true)}
          >
            Change editor type
          </button>
        ) : (
          <>
            <label htmlFor="editor-type">Editor Type</label>
            <select
              id="editor-type"
              value={mainStore.user.editorType}
              onChange={async ({ target: { value } }) => {
                await fetchPut({
                  url: "api/user",
                  data: {
                    ...mainStore.user,
                    editorType: value,
                  },
                });
                mainDispatch({
                  type: "MAIN_SET_USER",
                  user: { ...mainStore.user, editorType: value },
                });
              }}
            >
              <option id="trix-option" value="TRIX">
                WYSIWYG Editor
              </option>
              <option id="markdown-option" value="MARKDOWN">
                Markdown Editor
              </option>
            </select>
          </>
        )}
        <br />
      </div>
      {mainStore.user.editorType === "MARKDOWN" && (
        null
        //<MarkdownEditor {...props} />
      )}
      {(!mainStore.user.editorType || mainStore.user.editorType === "TRIX") && (
        <TrixEditor {...props} />
      )}
    </>
  );
}
